// extracted by mini-css-extract-plugin
export default {"loadButton":"style_loadButton__Z6zYF"};